import React, { Component } from 'react';
import SearchUserForm from '../../../components/Admin/User/SearchUser'
import UserGrid from '../../../components/Admin/User/UserGrid'
import { Link } from 'react-router-dom';
import {SearchUser,EditUser,SetCompany} from "../../../actions/loading"
import { connect } from "react-redux";
import AddUserForm from "./add.js"
import { CallAPI } from "../../../components/common/formsubmit";
import appConfig from "../../../config/config";


class SearchUserPage extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        CallAPI({}, 
            appConfig.apiGateway.getSearchDataUrl, 
            this.props, 
            "GetCompanyList", 
            this.props.LoadingDone, 
            this.props.SetCompany);
    }
    editUser=(cell, row)=> {
        return (
            <Link >{cell}</Link>
            );
    }
    colHeader = [
        { dataField: 'ID', text: 'ID', formatter: this.editUser},
        { dataField: 'FIRSTNAME', text: 'Name' },
        { dataField: 'EMAIL', text: 'Email' },
        { dataField: 'STATUS', text: 'Status' }
    ];
    dataColumns = this.colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true, formatter : d.formatter } });
    render(){
        return (
            <>
                <SearchUserForm/>
                <UserGrid OrderColumns={this.dataColumns} />
                <AddUserForm />
            </>
        )
    }
}
var searchUserPage = connect(
    state => ({
        session: state.session,
        UserData : state.UserData
    }),
    {EditUser,SetCompany}

)(SearchUserPage);


export default searchUserPage